import { call, options, params } from './helpers';

// Get all SOPs
export const getSops = (payload) => call(`/beta/sops${params(payload)}`);

// Get single SOP
export const getSop = ({ id }) => call(`/beta/sops/${id}`);

// Create new SOP
export const createSop = (payload) =>
	call(`/beta/sops`, options(payload, 'POST'));

// Update SOP
export const updateSop = ({ id, ...payload }) =>
	call(`/beta/sops/${id}`, options(payload, 'PUT'));

// Delete SOP
export const deleteSop = ({ id }) =>
	call(`/beta/sops/${id}`, options(null, 'DELETE'));

// Get approved SOPs only (for dropdowns in work orders, schedules)
export const getApprovedSops = (payload) =>
	call(`/beta/sops/approved${params(payload)}`);

// Publish a new version
// versionType: 'minor' (default) or 'major'
// signatureId: UUID of saved signature to use
// signatureData: base64 signature data (for one-time signatures)
export const publishSop = ({ id, versionType = 'minor', signatureId, signatureData }) =>
	call(`/beta/sops/${id}/publish`, options({ versionType, signatureId, signatureData }, 'POST'));

// Get latest published version (for comparing draft changes)
export const getSopLatestVersion = ({ id }) =>
	call(`/beta/sops/${id}/latest-version`);

// Get version history
export const getSopVersions = ({ id }) => call(`/beta/sops/${id}/versions`);

// Get specific version
export const getSopVersion = ({ id, version }) =>
	call(`/beta/sops/${id}/versions/${version}`);

// Compare two versions
export const compareSopVersions = ({ id, version1, version2 }) =>
	call(`/beta/sops/${id}/compare?version1=${version1}&version2=${version2}`);

// Upload image for SOP step
export const uploadSopImage = async (file) => {
	const formData = new FormData();
	formData.append('file', file);

	const user = JSON.parse(localStorage.getItem('user'));

	const response = await fetch(`${process.env.API_URL}/beta/sops/upload-image`, {
		method: 'POST',
		headers: {
			...(user?.jwtToken ? { Authorization: `Bearer ${user.jwtToken}` } : {}),
		},
		body: formData,
	});

	if (!response.ok) {
		throw new Error('Failed to upload image');
	}

	return response.json();
};

// Upload attachment for SOP step
export const uploadStepAttachment = async (file) => {
	const formData = new FormData();
	formData.append('file', file);

	const user = JSON.parse(localStorage.getItem('user'));

	const response = await fetch(`${process.env.API_URL}/beta/sops/upload-attachment`, {
		method: 'POST',
		headers: {
			...(user?.jwtToken ? { Authorization: `Bearer ${user.jwtToken}` } : {}),
		},
		body: formData,
	});

	if (!response.ok) {
		throw new Error('Failed to upload attachment');
	}

	return response.json();
};
